import React, { useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { localApi, catApi, roundUp } from "utils/imgApi";
import { useHistory, useLocation } from "react-router-dom";
import { BiFile } from "react-icons/bi";
import { PiCopy } from "react-icons/pi";
import { makeStyles } from "@material-ui/core/styles";
import Selects from "react-select";
import InputLabel from "@material-ui/core/InputLabel";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import AddIcon from "@material-ui/icons/Add";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Tooltip from "@material-ui/core/Tooltip";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import { FaBox, FaRing, FaUsers } from "react-icons/fa";
import { GiWireCoil, GiBoxUnpacking } from "react-icons/gi";
import { BsImages } from "react-icons/bs";
import { AiOutlineCalculator } from "react-icons/ai";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import styRadio from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import styDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styCheckbox from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styHoever from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

import { credentials } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(styRadio);
const useStyl = makeStyles(styDrop);
const useSty = makeStyles(styCheckbox);
const useStyleSweet = makeStyles(styleSweet);
const useHoever = makeStyles(styHoever);

export default function LeadsView(props) {
  const [itemClient, setItemClient] = React.useState([]);
  const [jobCart, setJobCart] = React.useState([]);

  const [copiedMetalId, setCopiedMetalId] = React.useState(null);
  const [copiedLabourId, setCopiedLabourId] = React.useState(null);
  const [copiedPackingId, setCopiedPackingId] = React.useState(null);

  const [simpleSelectClient, setSimpleSelectClient] = React.useState("");
  const [simpleSelectClientErr, setSimpleSelectClientErr] = React.useState("");
  const [clientid, setClientid] = React.useState("");
  const [clientDetails, setClientDetails] = React.useState("");

  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");

  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const [deleteJobCart, setDeleteJobCart] = React.useState(null);

  const classes = useStyles();
  const classesRadio = useStyle();
  const classe = useStyl();
  const classCheck = useSty();
  const classSweet = useStyleSweet();
  const history = useHistory();
  const classeHover = useHoever();

  let { avatar } = props;

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const cleanDecimalInput = (text) => {
    return text.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
  };

  const totalPiece = "18";

  async function getUserClient() {
    const api =
      localApi + `/clientGroup/list/byAdminId/${userObj && userObj.id}`;
    const results = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResults = await results.json();
    // setItemClient(getResults && getResults.filter((f) => f.type != "Crm"));
    // console.log(getResults);

    const updatedClientList = await Promise.all(
      getResults.map(async (f) => {
        const api =
          localApi +
          `/jobcart/byAdminIdAndJobClientId/${userObj && userObj.id}/${f.id}`;

        const result = await fetch(api, {
          method: "GET",
          headers: {
            Authorization: `Basic ${credentials}`,
          },
        });

        const getResult = await result.json();
        // const ress = getResult.filter((f) => f.cancelOrders != true);
        const ress = getResult;
        // console.log(ress);

        return {
          ...f,
          count: ress?.length, // 👈 adding count key
        };
      }),
    );

    // remove CRM type after adding count
    const filteredClients = updatedClientList.filter(
      (f) => f.type !== "Crm" && f.count != 0,
    );
    // console.log(filteredClients);
    setItemClient(filteredClients);
  }

  useEffect(() => {
    getUserClient();
  }, []);

  const handleClient = async (simpleSelectClient) => {
    if (simpleSelectClient.value) {
      let newSpli = simpleSelectClient.value.split("-");
      const ids = itemClient.find((f) => f.mobile === newSpli[1]);

      setClientDetails(ids);
      setClientid(ids.id);

      const api =
        localApi +
        `/jobcart/byAdminIdAndJobClientId/${userObj && userObj.id}/${ids.id}`;

      const result = await fetch(api, {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      });

      const getResult = await result.json();
      //   console.log(getResult);
      setJobCart(getResult);
    }
    setSimpleSelectClient(simpleSelectClient);
    setSimpleSelectClientErr("");
  };

  const copyMetalData = (j) => {
    try {
      const metalText = j.metalData
        .map((metal) => {
          return `*Metal:-*
Thaw Golwire: ${metal.golwireThaw}
Title: ${metal.metalTitle}
Metal Gram: ${metal.metalGram} x ${j.setsPcs} x ${j.box} = ${(
            Number(metal.metalGram) * Number(j.sizeTotal)
          ).toFixed(3)}
*Metal Price:* ${metal.metalPrice}
Metal Amount: ${(
            Number(metal.metalGram) *
            Number(j.sizeTotal) *
            Number(metal.metalPrice)
          ).toFixed(2)}`;
        })
        .join("\n\n");

      const sizeKeys = [
        "size1x8",
        "size1x9",
        "size1x10",
        "size1x11",
        "size1x12",
        "size1x13",
        "size1x14",
        "size1x15",
        "size2x0",
        "size2x1",
        "size2x2",
        "size2x3",
        "size2x4",
        "size2x5",
        "size2x6",
        "size2x7",
        "size2x8",
        "size2x9",
        "size2x10",
        "size2x11",
        "size2x12",
        "size2x13",
        "size2x14",
        "size2x15",
        "size3x0",
        "size3x1",
      ];

      const sizeText = sizeKeys
        .map((key) => {
          const value = j.sizeData?.[0]?.[key];

          if (Number(value) > 0) {
            return `${key.replace("size", "")}: ${(
              Number(value) /
              Number(j.setsPcs) /
              Number(j.box)
            ).toFixed(0)}`;
          }

          return null;
        })
        .filter(Boolean)
        .join("\n");

      const finalText = `${metalText}

Sizes:
${sizeText}

*Total Boxes:* ${(
        Number(j.sizeTotal) /
        Number(j.setsPcs) /
        Number(j.box)
      ).toFixed(0)}`;

      navigator.clipboard
        .writeText(finalText)
        .then(() => {
          setCopiedMetalId(j.id);

          setTimeout(() => {
            setCopiedMetalId(null);
          }, 1500);
        })
        .catch((err) => {
          console.log("Copy failed:", err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const copyLabourData = (j) => {
    try {
      const labourPerPiece = j.labourList.reduce(
        (total, item) => total + Number(item.price || 0),
        0,
      );

      const sizeKeys = [
        "size1x8",
        "size1x9",
        "size1x10",
        "size1x11",
        "size1x12",
        "size1x13",
        "size1x14",
        "size1x15",
        "size2x0",
        "size2x1",
        "size2x2",
        "size2x3",
        "size2x4",
        "size2x5",
        "size2x6",
        "size2x7",
        "size2x8",
        "size2x9",
        "size2x10",
        "size2x11",
        "size2x12",
        "size2x13",
        "size2x14",
        "size2x15",
        "size3x0",
        "size3x1",
      ];

      const sizeText = sizeKeys
        .map((key) => {
          const value = j.sizeData?.[0]?.[key];

          if (Number(value) > 0) {
            return `${key.replace("size", "")}: ${value}`;
          }

          return null;
        })
        .filter(Boolean)
        .join("\n");

      const text = `*Labour:-*
${j.labourList
  .map((l) => `${l.title}: ${Number(l.price || 0).toFixed(2)}`)
  .join("\n")}

*Labour Cost Per Piece:* ${labourPerPiece.toFixed(2)}
Total Labour: (${labourPerPiece.toFixed(2)} x ${j.sizeTotal}) = ${(
        labourPerPiece * Number(j.sizeTotal || 0)
      ).toFixed(2)}

Sizes:
${sizeText}

*Total Pieces:* ${j.sizeTotal}`;

      navigator.clipboard.writeText(text);

      setCopiedLabourId(j.id);

      setTimeout(() => {
        setCopiedLabourId(null);
      }, 1500);
    } catch (error) {
      console.log("Labour Copy Error:", error);
    }
  };

  const copyPackingData = (j) => {
    try {
      const totalBoxes =
        Number(j.sizeTotal || 0) / Number(j.setsPcs || 1) / Number(j.box || 1);

      const sizeKeys = [
        "size1x8",
        "size1x9",
        "size1x10",
        "size1x11",
        "size1x12",
        "size1x13",
        "size1x14",
        "size1x15",
        "size2x0",
        "size2x1",
        "size2x2",
        "size2x3",
        "size2x4",
        "size2x5",
        "size2x6",
        "size2x7",
        "size2x8",
        "size2x9",
        "size2x10",
        "size2x11",
        "size2x12",
        "size2x13",
        "size2x14",
        "size2x15",
        "size3x0",
        "size3x1",
      ];

      const sizeText = sizeKeys
        .map((key) => {
          const value = j.sizeData?.[0]?.[key];

          if (Number(value) > 0) {
            return `${key.replace("size", "")}: ${(
              Number(value) /
              Number(j.setsPcs || 1) /
              Number(j.box || 1)
            ).toFixed(0)}`;
          }

          return null;
        })
        .filter(Boolean)
        .join("\n");

      const text = j.packingData
        .map((packing) => {
          return `*Packing:-*
${packing.boxBrandName}: ${packing.boxPrice}

${packing.boxDesc} Packing Charges: ${Number(packing.boxPkgCharge || 0).toFixed(
            2,
          )}

${packing.packingOption}

${packing.packingDesc}: ${Number(packing.price || 0).toFixed(2)}

*Packing Cost:* ${Number(packing.packVal || 0).toFixed(2)}

Total Packing: (${Number(packing.packVal || 0).toFixed(
            2,
          )} x ${totalBoxes.toFixed(0)}) = ${(
            Number(packing.packVal || 0) * totalBoxes
          ).toFixed(2)}

Sizes:
${sizeText}

*Boxes:* ${totalBoxes.toFixed(0)}`;
        })
        .join("\n\n");

      navigator.clipboard
        .writeText(text)
        .then(() => {
          setCopiedPackingId(j.id);

          setTimeout(() => {
            setCopiedPackingId(null);
          }, 1500);
        })
        .catch((err) => {
          console.log("Copy failed:", err);
        });
    } catch (error) {
      console.log("Packing Copy Error:", error);
    }
  };

  const SubmitDeleteJobCart = async (j) => {
    // console.log(j);

    fetch(localApi + `/jobcart/delete/byJobCartId/${j.id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    })
      .then((res) => res.json())
      .then(async (res) => {
        console.log(res);

        if (res.message === "Deleted Successfully !!!") {
          const api = localApi + `/cart/findById/${j.cartId}`;

          const result = await fetch(api, {
            method: "GET",
            headers: {
              Authorization: `Basic ${credentials}`,
            },
          });

          const getResult = await result.json();
          const bodyData = {
            metalIssue: j.metal ? false : getResult.metalIssue,
            lbrIssue: j.making ? false : getResult.lbrIssue,
            pkgIssue: j.packing ? false : getResult.pkgIssue,
          };
          axios
            .put(
              `${localApi}/cart/update/jobCart/byAdminAndCartId/${j.adminId}/${j.cartId}`,
              bodyData, // Empty body if you don't need to send any data in the PUT request body
              {
                headers: {
                  Authorization: `Basic ${credentials}`,
                },
              },
            )
            .then((res) => {
              // console.log(res.data);
              if (res.data.message === "Data Updated Successfully !!!") {
                alertTypeOps("success");
                alertMsgOps("Deleted Successfully.");
                setSubmitted(true);
              }
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        } else {
          alertTypeOps("danger");
          alertMsgOps("Delete Failed.");
          setSubmitted(true);
        }
      })
      .catch((err) => {
        // console.log(err);
        alertTypeOps("danger");
        alertMsgOps("Something went wrong.");
        setSubmitted(true);
      });
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  const select = {
    width: "100%",
    maxWidth: 600,
  };

  const mystyle = {
    position: "fixed",
    bottom: "10px",
    right: "30px",
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      padding: 10,
    }),
    menu: (state) => ({
      color: "#d81b60",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return { ...provided, opacity, transition };
    },
  };

  const rowStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    margin: "4px 0",
    color: "#000",
    fontSize: "15px",
  };

  const rowTotalStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginTop: "8px",
    color: "#000",
    fontSize: "18px",
    fontWeight: "bold",
  };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <FaUsers />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Select Labour</small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {submitted && (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  />
                )}
                {confirmDelete && (
                  <SweetAlert
                    warning
                    showCancel
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                    cancelBtnCssClass={
                      classSweet.button + " " + classSweet.danger
                    }
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    title="Delete Job Cart?"
                    onConfirm={() => {
                      setConfirmDelete(false);
                      SubmitDeleteJobCart(deleteJobCart);
                    }}
                    onCancel={() => {
                      setConfirmDelete(false);
                      setDeleteJobCart(null);
                    }}
                  >
                    Are you sure you want to delete this Job Cart?
                  </SweetAlert>
                )}
                <GridItem xs={12} sm={12} md={12}>
                  <label className={classe.selectLabel}>
                    Select Company & Client Name
                  </label>
                  <Selects
                    styles={customStyles}
                    style={select}
                    required={true}
                    placeholder="Select Company & Client Name..."
                    value={simpleSelectClient}
                    name="simpleSelectClient"
                    onChange={handleClient}
                    options={
                      itemClient &&
                      itemClient.map((c) => {
                        return {
                          label:
                            c && c.company
                              ? c.company + "-" + c.mobile
                              : c.firstname + " " + c.lastname + "-" + c.mobile,
                          value:
                            c && c.company
                              ? c.company + "-" + c.mobile
                              : c.firstname + " " + c.lastname + "-" + c.mobile,
                        };
                      })
                    }
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        {jobCart &&
          jobCart.map((j) => {
            const hasPacking = (j.packingData?.length || 0) > 0;
            const hasLabour = (j.labourList?.length || 0) > 0;
            const hasMetal = (j.metalData?.length || 0) > 0;

            // Hide only when all 3 exist
            const hideCopyImage =
              hasPacking === true && hasLabour === true && hasMetal === true;

            // Line show when any 2 exist, but hide when all 3 exist
            const showLine =
              (hasPacking && hasLabour && !hasMetal) ||
              (hasPacking && hasMetal && !hasLabour) ||
              (hasLabour && hasMetal && !hasPacking);

            const createdDate = new Date(j.createDate);
            const currentDate = new Date();

            const diffTime = currentDate - createdDate;
            const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

            const dayText = totalDays <= 1 ? "Day" : "Days";
            return (
              <GridItem xs={12} sm={6} md={4} key={j.id}>
                <Card product className={classeHover.cardHover}>
                  <CardHeader image className={classeHover.cardHeaderHover}>
                    <img src={j.imageUrl} alt="..." />
                  </CardHeader>
                  <CardBody>
                    <div className={classeHover.cardHoverUnder}>
                      <Tooltip
                        id="tooltip-top"
                        title="Pdf"
                        placement="bottom"
                        classes={{ tooltip: classeHover.tooltip }}
                      >
                        <Button
                          href={`${localApi}/jobcart/byAdminAndJobClientAndCartAndIdJobCartPdf/${j.adminId}/${j.jobClientId}/${j.cartId}/${j.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          color="rose"
                          simple
                          justIcon
                        >
                          <PictureAsPdfIcon
                            className={classeHover.underChartIcons}
                          />
                        </Button>
                      </Tooltip>
                      <Tooltip
                        id="tooltip-top"
                        title="Remove"
                        placement="bottom"
                        classes={{ tooltip: classeHover.tooltip }}
                      >
                        <Button
                          color="danger"
                          simple
                          justIcon
                          onClick={() => {
                            setDeleteJobCart(j);
                            setConfirmDelete(true);
                          }}
                        >
                          <DeleteForeverIcon
                            className={classeHover.underChartIcons}
                          />
                        </Button>
                      </Tooltip>
                    </div>
                    <h5
                      className={classeHover.cardProductTitle}
                      style={{ color: "#d81b60" }}
                    >
                      Category: {j.categoryTitle}
                      <br />
                      Size-MM: {j.sizeMMTitle}
                      <br />
                      {`D${j.imageId}/P${j.productId}/C${j.cartId}-J${j.id}`}
                    </h5>
                    <div className={classeHover.cardProductDesciprion}>
                      {/* Metal Section */}
                      {j.metalData?.length > 0 && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <strong
                              style={{ fontSize: "15px", color: "black" }}
                            >
                              Metal:-
                            </strong>

                            {!hideCopyImage && (
                              <Button
                                color="rose"
                                simple
                                justIcon
                                onClick={() => copyMetalData(j)}
                              >
                                {copiedMetalId === j.id ? (
                                  <Check style={{ color: "green" }} />
                                ) : (
                                  <PiCopy />
                                )}
                              </Button>
                            )}
                          </div>

                          {j.metalData.map((metal, index) => (
                            <div key={index}>
                              <div style={rowStyle}>
                                <span>Thaw Golwire:</span>
                                <strong>{metal.golwireThaw}</strong>
                              </div>

                              <div style={rowStyle}>
                                <span>Title:</span>
                                <strong>{metal.metalTitle}</strong>
                              </div>

                              <div style={rowStyle}>
                                <span>
                                  Metal Gram: {metal.metalGram} x {j.setsPcs} x{" "}
                                  {j.box}
                                </span>
                                <strong>
                                  {(
                                    Number(metal.metalGram) *
                                    Number(j.sizeTotal)
                                  ).toFixed(3)}
                                </strong>
                              </div>

                              <div style={rowStyle}>
                                <span>Metal Price:</span>
                                <strong>{metal.metalPrice}</strong>
                              </div>

                              <div style={rowTotalStyle}>
                                <span>Metal Amount:</span>
                                <strong>
                                  {(
                                    Number(metal.metalGram) *
                                    Number(j.sizeTotal) *
                                    Number(metal.metalPrice)
                                  ).toFixed(2)}
                                </strong>
                              </div>
                            </div>
                          ))}

                          <hr
                            style={{
                              border: "1px solid #000",
                              margin: "10px 0",
                            }}
                          />

                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "10px",
                            }}
                          >
                            {[
                              "size1x8",
                              "size1x9",
                              "size1x10",
                              "size1x11",
                              "size1x12",
                              "size1x13",
                              "size1x14",
                              "size1x15",
                              "size2x0",
                              "size2x1",
                              "size2x2",
                              "size2x3",
                              "size2x4",
                              "size2x5",
                              "size2x6",
                              "size2x7",
                              "size2x8",
                              "size2x9",
                              "size2x10",
                              "size2x11",
                              "size2x12",
                              "size2x13",
                              "size2x14",
                              "size2x15",
                              "size3x0",
                              "size3x1",
                            ].map((key) => {
                              const value = j.sizeData?.[0]?.[key];

                              if (!value || Number(value) === 0) return null;

                              return (
                                <div
                                  key={key}
                                  style={{
                                    minWidth: "55px",
                                    textAlign: "center",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    padding: "4px",
                                  }}
                                >
                                  <div>{key.replace("size", "")}</div>
                                  <strong>{value}</strong>
                                </div>
                              );
                            })}
                          </div>

                          <h4 style={{ color: "black", marginTop: "10px" }}>
                            Total Boxes: {j.sizeTotal}
                          </h4>

                          {hideCopyImage && (
                            <hr
                              style={{
                                border: "1px solid #000",
                                margin: "10px 0",
                              }}
                            />
                          )}
                        </>
                      )}

                      {showLine && (
                        <hr
                          style={{ border: "1px solid #000", margin: "10px 0" }}
                        />
                      )}

                      {j.labourList?.length > 0 && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <strong
                              style={{ fontSize: "15px", color: "black" }}
                            >
                              Labour:-
                            </strong>

                            {!hideCopyImage && (
                              <Button
                                color="rose"
                                simple
                                justIcon
                                onClick={() => copyLabourData(j)}
                              >
                                {copiedLabourId === j.id ? (
                                  <Check style={{ color: "green" }} />
                                ) : (
                                  <PiCopy />
                                )}
                              </Button>
                            )}
                          </div>

                          {j.labourList.map((l, index) => (
                            <div key={index} style={rowStyle}>
                              <span>{l.title}</span>
                              <strong>{Number(l.price || 0).toFixed(2)}</strong>
                            </div>
                          ))}

                          <div style={rowStyle}>
                            <span>Labour Cost Per Piece:</span>
                            <strong>
                              {j.labourList
                                .reduce(
                                  (total, item) =>
                                    total + Number(item.price || 0),
                                  0,
                                )
                                .toFixed(2)}
                            </strong>
                          </div>

                          <div style={rowTotalStyle}>
                            <span>
                              Total Labour: (
                              {j.labourList
                                .reduce(
                                  (total, item) =>
                                    total + Number(item.price || 0),
                                  0,
                                )
                                .toFixed(2)}
                              {" X "}
                              {j.sizeTotal})
                            </span>

                            <strong>
                              {(
                                j.labourList.reduce(
                                  (total, item) =>
                                    total + Number(item.price || 0),
                                  0,
                                ) * Number(j.sizeTotal || 0)
                              ).toFixed(2)}
                            </strong>
                          </div>

                          <hr
                            style={{
                              border: "1px solid #000",
                              margin: "10px 0",
                            }}
                          />

                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "10px",
                            }}
                          >
                            {[
                              "size1x8",
                              "size1x9",
                              "size1x10",
                              "size1x11",
                              "size1x12",
                              "size1x13",
                              "size1x14",
                              "size1x15",
                              "size2x0",
                              "size2x1",
                              "size2x2",
                              "size2x3",
                              "size2x4",
                              "size2x5",
                              "size2x6",
                              "size2x7",
                              "size2x8",
                              "size2x9",
                              "size2x10",
                              "size2x11",
                              "size2x12",
                              "size2x13",
                              "size2x14",
                              "size2x15",
                              "size3x0",
                              "size3x1",
                            ].map((key) => {
                              const value = j.sizeData?.[0]?.[key];

                              if (!value || Number(value) === 0) return null;

                              return (
                                <div
                                  key={key}
                                  style={{
                                    minWidth: "55px",
                                    textAlign: "center",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    padding: "4px",
                                  }}
                                >
                                  <div>{key.replace("size", "")}</div>
                                  <strong>{value}</strong>
                                </div>
                              );
                            })}
                          </div>

                          <h4 style={{ color: "black", marginTop: "10px" }}>
                            Total Pieces: {j.sizeTotal}
                          </h4>

                          {hideCopyImage && (
                            <hr
                              style={{
                                border: "1px solid #000",
                                margin: "10px 0",
                              }}
                            />
                          )}
                        </>
                      )}

                      {showLine && (
                        <hr
                          style={{ border: "1px solid #000", margin: "10px 0" }}
                        />
                      )}

                      {/* Packing Section */}
                      {j.packingData?.length > 0 && (
                        <>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <strong
                              style={{ fontSize: "15px", color: "black" }}
                            >
                              Packing:-
                            </strong>

                            {!hideCopyImage && (
                              <Button
                                color="rose"
                                simple
                                justIcon
                                onClick={() => copyPackingData(j)}
                              >
                                {copiedPackingId === j.id ? (
                                  <Check style={{ color: "green" }} />
                                ) : (
                                  <PiCopy />
                                )}
                              </Button>
                            )}
                          </div>

                          {j.packingData.map((packing, index) => {
                            const totalBoxes =
                              Number(j.sizeTotal || 0) /
                              Number(j.setsPcs || 1) /
                              Number(j.box || 1);

                            return (
                              <div key={index}>
                                <div style={rowStyle}>
                                  <span>{packing.boxBrandName}</span>
                                  <strong>{packing.boxPrice}</strong>
                                </div>

                                <div style={rowStyle}>
                                  <span>{packing.boxDesc} Packing Charges</span>
                                  <strong>
                                    {Number(packing.boxPkgCharge || 0).toFixed(
                                      2,
                                    )}
                                  </strong>
                                </div>

                                <div
                                  style={{
                                    width: "100%",
                                    margin: "5px 0",
                                    color: "black",
                                    textAlign: "left",
                                  }}
                                >
                                  <strong>{packing.packingOption}</strong>
                                </div>

                                <div style={rowStyle}>
                                  <span>{packing.packingDesc}</span>
                                  <strong>{packing.price}</strong>
                                </div>

                                <div style={rowStyle}>
                                  <strong>Packing Cost:</strong>
                                  <strong>
                                    {Number(packing.packVal || 0).toFixed(2)}
                                  </strong>
                                </div>

                                <div style={rowTotalStyle}>
                                  <span>
                                    Total Packing: (
                                    {Number(packing.packVal || 0).toFixed(2)} x{" "}
                                    {totalBoxes.toFixed(0)})
                                  </span>

                                  <strong>
                                    {(
                                      Number(packing.packVal || 0) * totalBoxes
                                    ).toFixed(2)}
                                  </strong>
                                </div>
                              </div>
                            );
                          })}

                          <hr
                            style={{
                              border: "1px solid #000",
                              margin: "10px 0",
                            }}
                          />

                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "10px",
                            }}
                          >
                            {[
                              "size1x8",
                              "size1x9",
                              "size1x10",
                              "size1x11",
                              "size1x12",
                              "size1x13",
                              "size1x14",
                              "size1x15",
                              "size2x0",
                              "size2x1",
                              "size2x2",
                              "size2x3",
                              "size2x4",
                              "size2x5",
                              "size2x6",
                              "size2x7",
                              "size2x8",
                              "size2x9",
                              "size2x10",
                              "size2x11",
                              "size2x12",
                              "size2x13",
                              "size2x14",
                              "size2x15",
                              "size3x0",
                              "size3x1",
                            ].map((key) => {
                              const value = j.sizeData?.[0]?.[key];

                              if (!value || Number(value) === 0) return null;

                              return (
                                <div
                                  key={key}
                                  style={{
                                    minWidth: "55px",
                                    textAlign: "center",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    padding: "4px",
                                  }}
                                >
                                  <div>{key.replace("size", "")}</div>
                                  <strong>
                                    {(
                                      Number(value) /
                                      Number(j.setsPcs || 1) /
                                      Number(j.box || 1)
                                    ).toFixed(0)}
                                  </strong>
                                </div>
                              );
                            })}
                          </div>

                          <h4 style={{ color: "black", marginTop: "10px" }}>
                            Boxes:{" "}
                            {(
                              Number(j.sizeTotal || 0) /
                              Number(j.setsPcs || 1) /
                              Number(j.box || 1)
                            ).toFixed(0)}
                          </h4>
                        </>
                      )}
                      <div style={rowStyle}>
                        <span>
                          Issue Date:{" "}
                          {new Date(j.createDate).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })}
                        </span>

                        <strong>
                          {totalDays} {dayText}
                        </strong>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </GridItem>
            );
          })}
      </GridContainer>
    </div>
  );
}

LeadsView.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
